import { create } from 'zustand'
import theme from '../../../theme'
import { getLanguage } from '../../components/appBar/context/LocalizationContext'

interface IlertsGeneralControllersStore {
    showAlertSnackbar: boolean
    setShowAlertSnackbar: (value: boolean) => void
    setAlertSnackbarToggle: () => void
}

export const useAlertsGeneralControllersStore = create<IlertsGeneralControllersStore>((set, get) => ({
    showAlertSnackbar: false,
    setShowAlertSnackbar: (value: boolean) => {
        set({ showAlertSnackbar: value })
    },

    setAlertSnackbarToggle: () => {
        console.log('get().showAlertSnackbar: ', get().showAlertSnackbar)
        set({ showAlertSnackbar: !get().showAlertSnackbar })
    },
}))

interface IdataRender {
    title: string
    description: string
    color: string
    countText?: string
    secondMessage?: string
}

interface IAlertTextPS {
    setTextsInitial: (description: string) => void
    setTextFinally: (description: string) => void
    setTextError: (description: string) => void
    setTextSecondary: (description: string) => void
    // setCountPendingError: (total: number, pendings: number) => void
    setCountPendingError: (text: string) => void
    dataRenderInitial: IdataRender
    dataRenderFinally: IdataRender
    dataRenderError: IdataRender
    dataRender: IdataRender
    dataRenderSecondary?: IdataRender
}

export const useAlertTextPS = create<IAlertTextPS>((set, get) => ({
    dataRenderFinally: {
        title: 'Descarga de assets de Perfect Store finalizada', //languageFile.assets_download_completed,
        description: 'Descarga completa de foto de éxito', //languageFile.perfect_store_download,
        color: theme.colors.colorApproved,
    },
    dataRenderError: {
        title: 'Error en la descarga de assets de Perfect Store', //languageFile.perfect_store_error,
        description: 'Conexión interrumpida, se volverá a descomprimir foto de éxito cuando recuperes conexión.', //languageFile.connection_interrupted,
        color: theme.colors.error,
        countText: null,
    },
    dataRenderInitial: {
        title: 'Error en la descarga de assets de Perfect Store', //languageFile.perfect_store_error,
        description: 'Descargando foto de éxito...', //languageFile.decompressing_perfect_store,
        color: theme.colors.textPrimary,
    },

    dataRender: {
        title: '',
        description: '',
        color: '',
    },

    setTextsInitial: (description) => {
        set({
            dataRender: {
                ...get().dataRenderInitial,
                description,
            },
        })
    },

    setTextFinally: (description) => {
        set({
            dataRender: {
                ...get().dataRenderFinally,
                description,
            },
        })
    },

    setTextError: (description) => {
        set({
            dataRender: {
                ...get().dataRenderError,
                description,
            },
        })
    },
    setTextSecondary: (description) => {
        set({
            dataRender: {
                ...get().dataRender,
                secondMessage: description,
            },
        })
    },
    setCountPendingError: (textPendingError: string) => {
        if (!textPendingError) {
            return
        }

        set({
            dataRender: {
                ...get().dataRenderError,
                description: get().dataRender.description + textPendingError,
            },
        })
    },
}))
